// ----------------------------------------------------------------------------
// Component: UGC Testimonials
// ----------------------------------------------------------------------------
//
// UGC/Social testimonials section with images and videos
// - Grid layout for 1-4 items (left-aligned)
// - Slider for 5+ items
// - Video modals for video testimonials
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import $ from 'jquery';
import Swiper, { Navigation, Scrollbar, A11y } from 'swiper';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import './_ugc-testimonials.scss';


// -------------------------------------
// Initialize Sliders
// -------------------------------------

$(function() {
    $(".carousel--ugc-testimonials").each(function(index){
        var $this = $(this);
        var $wrapper = $this.closest('.ugc-testimonials__wrapper');
        var slideCount = $this.find('.swiper-slide').length;

        // If we have 4 or fewer items, use a simple grid and skip Swiper setup
        if (slideCount <= 4) {
            var tabletColumns = Math.max(Math.min(slideCount, 2), 1);
            var desktopColumns = Math.max(Math.min(slideCount, 4), 1);

            $wrapper.addClass('ugc-testimonials__wrapper--grid');
            $this.addClass('ugc-testimonials--grid');
            $this.find('.swiper-wrapper').addClass('ugc-testimonials__grid');
            $this.css('--ugc-grid-columns-tablet', tabletColumns);
            $this.css('--ugc-grid-columns-desktop', desktopColumns);
            return;
        }

        // Generate unique class for each UGC testimonials slider
        $this.addClass("ugc-testimonials-instance-" + index);

        // Generate unique btn classes for slider arrows
        $this.parents('.ugc-testimonials__wrapper').find(".swiper-button-prev").addClass("ugc-testimonials-btn-prev-" + index);
        $this.parents('.ugc-testimonials__wrapper').find(".swiper-button-next").addClass("ugc-testimonials-btn-next-" + index);

        // Generate unique btn classes for slider scrollbar
        $this.find(".swiper-scrollbar").addClass("ugc-testimonials-swiper-scrollbar-" + index);

        var swiper = new Swiper(".ugc-testimonials-instance-" + index, {
            // Optional parameters
            modules: [Navigation, Scrollbar, A11y],
            slidesPerView: 4,
            spaceBetween: 10,
            observer: true,
            observeParents: true,
            a11y: false,

            breakpoints: {
                // when window width is < 680px (mobile)
                0: {
                    slidesPerView: 1.4,
                    spaceBetween: 10
                },
                // when window width is >= 680px (tablet)
                680: {
                    slidesPerView: 4,
                    spaceBetween: 30
                },
                // when window width is >= 1024px (laptop)
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 50
                }
            },

            // Navigation arrows
            navigation: {
                nextEl: ".ugc-testimonials-btn-next-" + index,
                prevEl: ".ugc-testimonials-btn-prev-" + index
            },

            scrollbar: {
                el: ".ugc-testimonials-swiper-scrollbar-" + index,
                draggable: true,
            },
        });
    });
});


// -------------------------------------
// Social Media Video Keyboard Controls
// -------------------------------------

$(function() {
    // Handle spacebar play/pause for TikTok and Instagram videos in modals
    $(document).on('keydown', function(e) {
        // Check if a social video modal is open
        const openModal = $('.modal--social-video.js--isOpen');

        if (openModal.length > 0 && (e.key === ' ' || e.keyCode === 32)) {
            e.preventDefault(); // Prevent page scroll

            // TikTok video controls
            const tiktokVideo = openModal.find('.tiktok-embed iframe');
            if (tiktokVideo.length > 0) {
                // TikTok embeds don't expose play/pause controls via iframe API
                // Focus the video element so users can use native TikTok controls
                tiktokVideo.focus();
            }

            // Instagram video controls
            const instagramVideo = openModal.find('.instagram-media iframe');
            if (instagramVideo.length > 0) {
                // Instagram embeds don't expose play/pause controls via iframe API
                // Focus the video element so users can use native Instagram controls
                instagramVideo.focus();
            }
        }
    });

    // Ensure social video embeds are focusable when modal opens
    $(window).on('open.modal', function(event, modal) {
        const socialEmbed = $(modal).find('.social-video-embed');
        if (socialEmbed.length > 0) {
            // Make iframe focusable
            socialEmbed.find('iframe').attr('tabindex', '0');
            // Focus the embed container for keyboard interaction
            setTimeout(function() {
                socialEmbed.focus();
            }, 300); // Small delay to ensure embed is loaded
        }
    });
});
